import Row from 'components/common/Row';
import Text from 'components/common/Text';
import React from 'react';
import styled, { css } from 'styled-components';
import { Product, ProductKind } from 'types/api';
import { EXCEPT_HEIGHT } from '..';
import {
  ADDRESS_MOCK,
  CATEGORY_MOCK,
  GuideMockData,
  HOSTING_MOCK,
  KIND_MOCK,
  ONLINE_MOCK,
  SHIP_MOCK,
} from '../hooks/GuideMock';
import { ProductParamInput } from '../hooks/types';
import { RegistPageNumber } from '../hooks/useProductRegistHooks';
import ChapterFive from './BasicInformation/ChapterFive';
import ChapterFour from './BasicInformation/ChapterFour';
import ChapterOne from './BasicInformation/ChapterOne';
import ChapterThree from './BasicInformation/ChapterThree';
import ChapterTwo from './BasicInformation/ChapterTwo';
import GuideContainer from './GuideContainer';

const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;

  width: 100%;
  max-width: 1200px;
  /* min-height: 81vh; */
  overflow-y: scroll;
  background-color: #fff;

  ${({ $isMobile }) =>
    !$isMobile &&
    css`
      border-left: 1px solid #eaebec;
      border-right: 1px solid #eaebec;
    `}
`;

interface BasicInformationRegistIProps {
  isMobile: boolean;
  height: number;
  productParamInput: ProductParamInput;
  registPageNumber: RegistPageNumber;
  imageThumbnail: string[];
  isOpenGuideModal: boolean;
  setProductParamInput: React.Dispatch<React.SetStateAction<ProductParamInput>>;
  handleOnChangeProductParamInput: (key: string, value: any) => void;
  handleOpenGuideModal: (isOpen: boolean) => void;
}

const BasicInformationRegist: React.FC<
  BasicInformationRegistIProps
> = props => {
  const {
    isMobile,
    height,
    productParamInput,
    registPageNumber,
    imageThumbnail,
    isOpenGuideModal,
    setProductParamInput,
    handleOnChangeProductParamInput,
    handleOpenGuideModal,
  } = props;

  const innerHeight = height - EXCEPT_HEIGHT;

  const renderBasicInformation = (): JSX.Element => {
    switch (registPageNumber.basicPageNumber.page) {
      case 0: {
        return (
          <ChapterOne
            isMobile={isMobile}
            productParamInput={productParamInput}
            imageThumbnail={imageThumbnail}
            handleOnChangeProductParamInput={handleOnChangeProductParamInput}
          />
        );
      }
      case 1: {
        return (
          <ChapterTwo
            isMobile={isMobile}
            productParamInput={productParamInput}
            setProductParamInput={setProductParamInput}
          />
        );
      }
      case 2: {
        return (
          <ChapterThree
            isMobile={isMobile}
            productParamInput={productParamInput}
            setProductParamInput={setProductParamInput}
            handleOnChangeProductParamInput={handleOnChangeProductParamInput}
          />
        );
      }
      case 3: {
        return (
          <ChapterFour
            isMobile={isMobile}
            productParamInput={productParamInput}
            handleOnChangeProductParamInput={handleOnChangeProductParamInput}
          />
        );
      }
      case 4: {
        return (
          <ChapterFive
            isMobile={isMobile}
            productParamInput={productParamInput}
            setProductParamInput={setProductParamInput}
            handleOnChangeProductParamInput={handleOnChangeProductParamInput}
          />
        );
      }
    }

    return <></>;
  };

  const getMockData = (): GuideMockData[] => {
    switch (registPageNumber.basicPageNumber.page) {
      case 1: {
        return HOSTING_MOCK;
      }
      case 2: {
        if (productParamInput.kind === ProductKind.GOODS) {
          return SHIP_MOCK;
        }
        return KIND_MOCK;
      }
      case 3: {
        if (productParamInput.kind === ProductKind.ONLINE) {
          return ONLINE_MOCK;
        }
        return ADDRESS_MOCK;
      }
      case 4: {
        return CATEGORY_MOCK;
      }
    }
  };

  return (
    <Container
      $isMobile={isMobile}
      style={{
        justifyContent:
          isMobile || registPageNumber.basicPageNumber.page !== 0
            ? 'flex-start'
            : 'center',
        padding: isMobile ? '0 20px 64px 20px' : '',
        height: `${innerHeight}px`,
      }}
    >
      {isMobile ? (
        <React.Fragment>
          {renderBasicInformation()}
          {isOpenGuideModal && (
            <GuideContainer
              isMobile={isMobile}
              mockData={getMockData()}
              onClose={() => handleOpenGuideModal(false)}
            />
          )}
        </React.Fragment>
      ) : (
        <Row style={{ width: '100%' }} align="flex-start">
          {registPageNumber.basicPageNumber.page > 0 ? (
            <React.Fragment>
              <Row
                align="flex-start"
                style={{
                  padding: '0 40px',
                  position: 'sticky',
                  top: '89px',
                  overflowY: 'scroll',
                  width: '100%',
                  height: `${innerHeight}px`,
                  zIndex: 11,
                  backgroundColor: '#fff',
                }}
              >
                {renderBasicInformation()}
              </Row>
              <Row
                align="flex-start"
                style={{
                  padding: '0 0 60px',
                  position: 'sticky',
                  top: '89px',
                  overflowY: 'scroll',
                  minWidth: '410px',
                  maxWidth: '410px',
                  height: `${innerHeight}px`,
                  borderLeft: '1px solid #eaebec',
                  backgroundColor: '#fff',
                }}
              >
                <GuideContainer
                  isMobile={isMobile}
                  mockData={getMockData()}
                  onClose={() => handleOpenGuideModal(false)}
                />
              </Row>
            </React.Fragment>
          ) : (
            renderBasicInformation()
          )}
        </Row>
      )}
    </Container>
  );
};

export default BasicInformationRegist;
